export function telemetryUrl(href: string): string {
  try {
    const u = new URL(href);
    return `${u.origin}${u.pathname}`;
  } catch {
    return href.split(/[?#]/)[0];
  }
}
